import { IOrderCancellationRequestDto } from "../interface/IOrderCancellationRequestDto"
import { OrderStatus } from "../enum/OrderEnum"
import { OrderDto } from "./OrderDto"

export const orderCancellationRequestDto: IOrderCancellationRequestDto = {
  id: "",
  orderId: "",
  userId: "",
  userType: 0,
  requestTime: new Date(),
  reason: "",
  orderStatusSnapshot: OrderStatus.Pending,
  isOpen: false,
  isWholeOrder: false,
  userRequestRefundPercentage: 0,
  merchConfirmationRefundPercentage: 0,
  order: OrderDto,
  orderCancellationItems: [],
  userRequestRefundAmount: 0,
}
